import axios from './../../config/axios';

function get({itemID}) {
    return axios().get("/purchase/price-checker", {
        params: {
            item_id: itemID
        }
    })
}

export default {
    get
}